import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidemenu from '../base/sidemenu';
import { deleteAdmin } from "../../services/adminService";

export default function AdminDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const admin = location.state?.admin || {};
  const token = localStorage.getItem("token");
  console.log("관리자 상세 ", admin)
  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDelete = async () => {
    if (!window.confirm("정말 이 관리자를 삭제하시겠습니까?")) return;

    try {
      const result = await deleteAdmin(admin.id, token);

      if (result.success === false) {
        alert(result.message);
        return;
      }
      alert(result.message);
      navigate("/admin");
    } catch (error) {
      console.error("삭제 실패:", error);
      alert("관리자 삭제에 실패했습니다.");
    }
  };

  return (
    <div className='flex'>
      <Sidemenu />
      <div className="admin">
        <h1>관리자 관리</h1>
        <div className="admin_box">
          <div className="admin_detail">
            <h2 className="subpage_title"><span className="before"><span className="nametit">{admin.name}</span>의 상세정보</span></h2>
            <div className="detail_box">
              <ul>
                <li><p className="tit">이름</p><p className="txt">{admin.name || "-"}</p></li>
                <li><p className="tit">아이디</p><p className="txt">{admin.username || "-"}</p></li>
                <li><p className="tit">휴대폰 번호</p><p className="txt">{admin.mobile_phone || "-"}</p></li>
                <li><p className="tit">내선번호</p><p className="txt">{admin.phone || "-"}</p></li>
                <li><p className="tit">이메일</p><p className="txt">{admin.email?.trim() ? admin.email : "-"}</p></li>
                <li><p className="tit">소속</p><p className="txt">{admin.department || "-"}</p></li>
                <li><p className="tit">권한</p><p className="txt">{admin.auth_name || "-"}</p></li>
                <li><p className="tit">최근 접속</p><p className="txt">{admin.last_login || "-"}</p></li>
              </ul>
            </div>
          </div>
          <div className="btn-group">
            <button className="btncolor02" onClick={handleDelete}>삭제</button>
            <button className="btncolor04" onClick={() => navigate("/admin/edit", { state: { admin } })}>수정</button>
            <button className="btncolor01" onClick={handleGoBack}>확인</button>
          </div>
        </div>
      </div>
    </div>
  );
}
